import type { ImplantReference } from "@jasper/client-models";
import {
  ListImplantReferencesDocument,
  type ListImplantReferencesQuery,
} from "../../gql/generated/graphql";
import { useQuery } from "@apollo/client";

const mapImplantReference = (
  implantReference: ListImplantReferencesQuery["listImplantReferences"][number]
): ImplantReference => ({
  id: implantReference.id,
  brand: implantReference.brand,
  reference: implantReference.referenceName,
  platforms: implantReference.platforms ?? [],
});

export const useImplantReferences = () => {
  const { data, loading, error } = useQuery(ListImplantReferencesDocument);

  const implantReferences: ImplantReference[] =
    data?.listImplantReferences?.map(mapImplantReference) ?? [];

  return { implantReferences, isLoading: loading, error };
};
